import { upsertListingDetails, updateListingFields } from './repository/listingRepository.js'

export const getListingUri = (listingMaaklerId) => {
  return "/#/listing/"+listingMaaklerId
}

export const updateListingDetails=(listingId, detailsType, details)=>{
  return upsertListingDetails(listingId, detailsType, details)
}

export const updateListingVideos=({listingId, videos})=>{
  console.log('updateListingVideos | listingId, videos:', listingId, videos);
  
  return updateListingFields({id:listingId, updates: {'videos': videos}})
}


// WEBPACK FOOTER //
// ./src/listings/listingService.js